/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TrustedCompanyContent } from '../../models/trusted-company-content';
import { TrustedCompanyContentApiRespModel } from '../../models/trusted-company-content-api-resp-model';

export interface ApiMasterTrustedCompanyContentEditPost$Params {
      body?: TrustedCompanyContent
}

export function apiMasterTrustedCompanyContentEditPost(http: HttpClient, rootUrl: string, params?: ApiMasterTrustedCompanyContentEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<TrustedCompanyContentApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiMasterTrustedCompanyContentEditPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TrustedCompanyContentApiRespModel>;
    })
  );
}

apiMasterTrustedCompanyContentEditPost.PATH = '/api/Master/TrustedCompanyContent/Edit';
